import { AccountRepository } from '~repositories/AccountRepository';
import { diContainer, serviceNames } from '~setup/diContainer';

export class AccountSidebarLoadedUseCase {
    private accountRepository: AccountRepository;

    constructor() {
        this.accountRepository = diContainer.get(serviceNames.accountRepository);
    }

    public async execute() {
        return this.accountRepository.fetchData();
    }
}
